import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { InventoryService } from '../../services/inventory/inventory.service';
import { SupplierModel } from "../../models/suppliers/supplier.model";
import { SupplierOrderDetailsComponent } from "./supplier-order-details/supplier-order-details.component";
import { AuthenticationService } from "../../../share-modul/services/authentication/authentication.service";
import { MenuService } from "../../services/menus/menu.service";
import { UserModel } from "../../../share-modul/models/user/user.model";
import * as moment from "moment/moment";
import { Calendar } from "primeng/calendar";
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.scss']
})
export class SuppliersComponent  implements OnInit, OnDestroy {

  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  public venueId: string | null;
  public venueIdUpdateSubscription: Subscription;
  public suppliersList: Array<SupplierModel>;
  public dateRange: any;
  public user: UserModel;
  public currency: string;
  @ViewChild('rangeCalendar') myCalendar: Calendar;
  isTouch: boolean;

  constructor(
    private dialogService: DialogService,
    private messageService: MessageService,
    private translate: TranslateService,
    private inventoryService: InventoryService,
    private menuService: MenuService,
    private currentVenueHelper: CurrentVenueHelperService,
    private authService: AuthenticationService,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    this.isTouch = window.innerWidth < 550;
    window.addEventListener('resize', this.handleResize.bind(this));
    this.suppliersList = new Array<SupplierModel>();
  }

  ngOnInit(): void {
    this.authService.loginUser.subscribe(user => {
      this.user = user!;
      if(this.user){
        this.getDefaultCurrency();
      }
    });
    this.route.params.subscribe(params => {
      if(params['venue-id'] != null){
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.loadSuppliersByVenue(new Date(), new Date());
      }
    });

  }

  public handleResize(): void {
    this.isTouch = window.innerWidth < 550;
    this.myCalendar.touchUI = this.isTouch;
  }

  public loadSuppliersByVenue(fromDate: Date, toDate: Date): void {
    this.spinner = true;
    const fromDateStr = moment(fromDate).format('yyyy-MM-DD HH:mm:ss');
    const toDateStr = moment(toDate).endOf('day').format('yyyy-MM-DD HH:mm:ss');
    this.inventoryService.loadSuppliersForVenue(this.venueId!, fromDateStr, toDateStr)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.suppliersList = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  public loadSuppliersByVenueInDateRange(): void {
    if (this.dateRange && this.dateRange[0] != null) {
        if(this.dateRange[1] == null) {
          this.loadSuppliersByVenue(this.dateRange[0], this.dateRange[0]);
        }else {
        this.loadSuppliersByVenue(this.dateRange[0], this.dateRange[1]);
      }
    }
  }

  public openOrderDetailsPopup(supplierName: string,venueId: string): void {
    this.dialogService.open(SupplierOrderDetailsComponent, {
      data: {
        name: supplierName,
        venueId: venueId
      },
      header: this.translate.instant('SUPPLIERS.ORDER_DETAILS'),
      width: '575px',
      styleClass: 'supplier-order-details-popup'
    });
  }

  public getDefaultCurrency(): void {
    let companyId = this.authService.getCompanyId();
    this.menuService.getDefaultCurrency(companyId, this.user.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.currency = response.symbol;
        }
      });
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

}
